import controller from './member-breakdown.controller.js';

let memberBreakdownModule = angular.module('member-breakdown', [])

    .directive('memberBreakdown', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: {},
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default memberBreakdownModule;



// WEBPACK FOOTER //
// ./src/app/angular/member-breakdown/member-breakdown.js